// This file can be replaced during build by using the `fileReplacements` array.
// `ng build ---prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: false,
 apiUrl: "http://mst2019b2.eastus.cloudapp.azure.com:3000/api",
  maintenanceUrl: "http://www.rentblazr.com/Dashboard",  //Live Url

  //  apiUrl: "http://mst2019b2.eastus.cloudapp.azure.com:3000/api",
//   maintenanceUrl: "http://mst2019b2.eastus.cloudapp.azure.com:8080/RentBlazr_QA"

  // apiUrl: "http://localhost:3000/api",
  //  maintenanceUrl: "http://localhost:4200",

  firebase: {
    apiKey: "AIzaSyAlqvE_6nseJN8UjVEp7XZhSUsL1fW6EDA",
    authDomain: "rentblazr-fa852.firebaseapp.com",
    databaseURL: "https://rentblazr-fa852.firebaseio.com",
    projectId: "rentblazr-fa852",
    storageBucket: "rentblazr-fa852.appspot.com",
    messagingSenderId: "849203657818",
    appId: "1:849203657818:web:6d62d28875faa864202c63"
  },

  stateList: [
    "Washington DC",
    "Alabama",
    "Alaska",
    "Arizona",
    "Arkansas",
    "California",
    "Colorado",
    "Connecticut",
    "Delaware",
    "Florida",
    "Georgia",
    "Hawaii",
    "Idaho",
    "Illinois",
    "Indiana",
    "Iowa",
    "Kansas",
    "Kentucky",
    "Louisiana",
    "Maine",
    "Maryland",
    "Massachusets",
    "Michigan",
    "Minnesota",
    "Mississippi",
    "Missouri",
    "Montana",
    "Nebraska",
    "Nevada",
    "New Hampshire",
    "New Jersey",
    "New Mexico",
    "New York",
    "North Carolina",
    "North Dakota",
    "Ohio",
    "Oklahoma",
    "Oregon",
    "Pennsylvania",
    "Rhode Island",
    "South Carolina",
    "South Dakota",
    "Tennessee",
    "Texas",
    "Utah",
    "Vermont",
    "Virginia",
    "Washington",
    "West Virginia",
    "Wisconsin",
    "Wyoming"
  ]
};

/*
 * In development mode, to ignore zone related error stack frames such as
 * `zone.run`, `zoneDelegate.invokeTask` for easier debugging, you can
 * import the following file, but please comment it out in production mode
 * because it will have performance impact when throw error
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
